<template>
  <div class="app-phone_ape">

    <input-title :required="options.required" :description="options.description"/>

    <div class="input-groups">

      <div
        v-for="(value, i) in valueLocal"
        :key="'input-group-' + i"
        :class="{ 'child-has-error': error[i] }"
        class="input-group"
        @click="removeError(i)">

        <div class="ape_inputs">

          <el-select
            v-model="value.code"
            placeholder="Выберите"
            clearable
            filterable
            class="input-code ape_code">
            <el-option
              v-for="item in codes"
              :key="`${item.code}-${item.country}`"
              :value="item.code">
              <span>{{ item.code }} &nbsp; {{ item.country }}</span>
            </el-option>
          </el-select>

          <masked-input
            v-model="value.number"
            type="text"
            :key="'number-' + i"
            class="input-base-style ape_number"
            :mask="[
              /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/
            ]"
            :guide="false"
            :showMask="false"
            placeholder="Номер телефона"/>

        </div>

        <div v-if="error[i]" class="ait_message ait_message--error">
          {{ error[i] }}</div>

      </div>

    </div>

    <add-rem-btns/>

  </div>
</template>

<script>
/* eslint-disable no-confusing-arrow */
import MaskedInput from 'vue-text-mask';
import codes from '../../../data/country-phone-codes';
import Common from './mixins/Common';

export default {

  components: {
    MaskedInput,
  },

  mixins: [Common],

  data() {
    return {
      valueBase: { code: '+7', number: '' },
      errorBase: '',
      codes,
    };
  },

  methods: {

    setValue(source) {
      const pts = source[0].split(' ');
      this.valueLocal[0].code = pts[0];
      this.valueLocal[0].number = pts[1];
    },

    // Return errors array for all fields
    getError() {
      // Validate if required
      if (this.options.required) {
        this.valueLocal.forEach((el, i) => {
          if (!el.code || !el.number) {
            this.error[i] = this.validateMessages.required;
          }
        });
      }
      this.updateValue();
      return this.error;
    },

    getValue() {
      const values = [];
      this.value.forEach((value, i) => {
        if (value.code && value.number) {
          const number = value.number.replace(/-/g, '');
          values[i] = `${value.code} ${number}`;
        }
      });

      if (this.options && this.options.multiple) {
        return values;
      }

      if (values[0]) {
        return values[0];
      }

      return '';
    },

  },

};
</script>

<style lang="scss">
.app-phone_ape {
  .ape_inputs {
    padding-left: 130px;
    position: relative;
  }
  .ape_code {
    width: 120px;
    position: absolute;
    left: 0;
    top: 0;
  }
  .ape_number {
    width: 100%;
  }
  @media (max-width: 450px) {
    .ape_inputs {
      padding-left: 90px;
    }
    .ape_code {
      width: 80px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/inputs/widgets/AppPhone.vue